import React, { useState, useEffect } from 'react';
import StepCard from './components/StepCard';
import ToggleSwitch from './components/ToggleSwitch';
import { Button } from '../../../components/ui/button';
import { Select, SelectItem } from '../../../components/ui/select';
import AppShell from '../../../components/AppShell';
import { Badge } from '../../../components/ui/badge';
import { useNavigate } from 'react-router-dom';
import { fetchWithAuth } from '../../../utils/fetchWithAuth';

const API = process.env.REACT_APP_API_BASE;

export default function ReplyBotOnboarding() {
  const navigate = useNavigate();

  const [instagramConnected, setInstagramConnected] = useState(false);
  const [whatsappConnected, setWhatsappConnected] = useState(false);
  const [whatsappDetails, setWhatsappDetails] = useState({
    phoneNumber: '',
    displayName: '',
    verifiedName: ''
  });
  const [wabaSaved, setWabaSaved] = useState(false);
const [tokenSaved, setTokenSaved] = useState(false);
  
  const [tone, setTone] = useState('friendly');
  const [language, setLanguage] = useState('en');
  const [ctaStyle, setCtaStyle] = useState('direct');
  const [autoReplyInstagram, setAutoReplyInstagram] = useState(true);
  const [autoReplyWhatsApp, setAutoReplyWhatsApp] = useState(true);
  const [showCodeInput, setShowCodeInput] = useState(false);
const [verificationCode, setVerificationCode] = useState('');


  // Load Meta SDK
  useEffect(() => {
    window.fbAsyncInit = function () {
      console.log("FB.init called");
      window.FB.init({
        appId: process.env.REACT_APP_META_APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: 'v23.0',
      });
    };

    (function (d, s, id) {
      if (d.getElementById(id)) return;
      const js = d.createElement(s);
      js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      js.async = true;
      js.defer = true;
      const fjs = d.getElementsByTagName(s)[0];
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'facebook-jssdk');

    // Listen for messages from Embedded Signup
    window.addEventListener('message', (event) => {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }
      try {
        const data = JSON.parse(event.data);
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          if (data.event === 'FINISH') {
            console.log('Signup completed:', data.data);
            const { waba_id, phone_number_id } = data.data;
  
            // ✅ Call save-waba API
            (async () => {
              const res = await fetchWithAuth(`${API}/api/whatsapp/save-waba`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                body: JSON.stringify({
                  wabaId: waba_id,
                  phoneNumberId: phone_number_id
                })
              });
  
              if (res.ok) {
                console.log('WABA saved');
                setWabaSaved(true);
                
              } else {
                console.error('Failed to save WABA');
              }
            })();
          } else if (data.event === 'CANCEL') {
            console.warn('Signup cancelled at step:', data.data.current_step);
          } else if (data.event === 'ERROR') {
            console.error('Signup error:', data.data.error_message);
          }
        }
      } catch {
        console.log('Non-JSON message:', event.data);
      }
    });
  }, []);

  // Fetch connect status
  useEffect(() => {
    const fetchStatus = async () => {
      const res = await fetchWithAuth(`${API}/api/replybot/status`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      const data = await res.json();
      setInstagramConnected(data.instagramConnected);
      setWhatsappConnected(data.whatsappConnected);

      if (data.whatsappConnected) {
        setWhatsappDetails({
          phoneNumber: data.phoneNumber || '',
          displayName: data.displayName || '',
          verifiedName: data.verifiedName || ''
        });
      }

      if (data.whatsappConnected) {
       // navigate(`/app/replybot/inbox`);
      }
    };
    fetchStatus();
  }, [navigate]);


  const disconnectWhatsApp = async () => {
    if (!window.confirm('Are you sure you want to disconnect WhatsApp?')) return;
    try {
      const res = await fetchWithAuth(`${API}/api/whatsapp/disconnect`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      if (res.ok) {
        setWhatsappConnected(false);
        setWabaSaved(false);
        setTokenSaved(false);
        setWhatsappDetails({});
        console.log('Disconnected successfully');
      } else {
        console.error('Failed to disconnect');
      }
    } catch (err) {
      console.error('Error disconnecting:', err);
    }
  };
  

  // Parse setup_token from URL (if still needed)
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const setupToken = urlParams.get('setup_token');
    if (setupToken && !whatsappConnected) {
      finalizeWhatsAppConnection(setupToken);
    }
  }, [whatsappConnected]);

  const finalizeWhatsAppConnection = async (setupToken) => {
    try {
      const res = await fetchWithAuth(`${API}/api/replybot/oauth/finalize`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({ type: 'whatsapp', code: setupToken }),
      });

      if (res.ok) {
        setWhatsappConnected(true);
        navigate('/app/replybot/inbox');
      } else {
        console.error('Failed to finalize WhatsApp connection');
      }
    } catch (err) {
      console.error('Finalize error:', err);
    }
  };

  // Start WhatsApp Embedded Signup (NEW official approach)
  const startWhatsAppSignup = () => {
    if (!window.FB) {
      console.error('FB SDK not loaded.');
      return;
    }
    console.log('Launching Embedded Signup...');
  
    window.FB.login(
      (response) => {
        console.log('FB.login response:', response);
  
        if (response.authResponse) {
          const code = response.authResponse.code;
          console.log('Auth Code:', code);
  
          // ✅ Call exchange-code API
          (async () => {
            const res = await fetchWithAuth(`${API}/api/whatsapp/exchange-code`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
              body: JSON.stringify({ code }),
            });
  
            if (res.ok) {
              console.log('Token saved');
              setTokenSaved(true);
              
            } else {
              console.error('Failed to exchange code');
            }
          })();
        } else if (response && response.error_message) {
          console.error('WhatsApp signup error:', response.error_message);
        } else {
          console.warn('WhatsApp signup canceled or no code returned.');
        }
      },
      {
        config_id: process.env.REACT_APP_META_WHATSAPP_CONFIG_ID,
        response_type: 'code',
        override_default_response_type: true,
        extras: { version: 'v3' },
      }
    );
  };

  const maybeFinalize = async () => {
  
    console.log('Both steps done, finalizing...');
    const res = await fetchWithAuth(`${API}/api/whatsapp/finalize-connection`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    if (res.ok) {
      console.log('WhatsApp connected successfully');
      setWhatsappConnected(true);
    } else {
      console.error('Failed to finalize WhatsApp connection');
    }
  
};
  
  
  
  
  

  const handleSaveConfig = () => {
    console.log({
      tone,
      language,
      ctaStyle,
      autoReplyInstagram,
      autoReplyWhatsApp,
    });
    navigate(`/app/replybot/inbox`);
  };

  return (
    <AppShell>
      <div className="col-span-12 space-y-6">
        <div className="max-w-3xl mx-auto py-10 px-4 space-y-6">
          <StepCard title="Welcome to ReplyBot">
            <p className="text-muted-foreground">
              Connect your Instagram and WhatsApp accounts to let ReplyBot handle your DMs with AI-powered responses.
            </p>
          </StepCard>

          <StepCard title="Connect Instagram">
            {instagramConnected ? (
              <Badge variant="success">Instagram Connected ✅</Badge>
            ) : (
              <Button onClick={() => launchOAuthConnect('instagram')}>
                🔗 Connect Instagram
              </Button>
            )}
          </StepCard>

          <StepCard title="Connect WhatsApp">
  {whatsappConnected ? (
    <>
      <Badge variant="success">WhatsApp Connected ✅</Badge>
      <div className="mt-2 text-sm text-muted-foreground space-y-1">
      {whatsappDetails.phoneNumber && (
  <div className="flex flex-col gap-2">
    <div className="flex items-center gap-2">
      <div>
        <strong>Phone:</strong> {whatsappDetails.phoneNumber}
      </div>
      <Button
        variant="outline"
        size="xs"
        onClick={async () => {
          try {
            const res = await fetchWithAuth(`${API}/api/whatsapp/request-code`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
            });
            if (res.ok) {
              alert('Verification code sent to the phone.');
              setShowCodeInput(true);
            } else {
              const data = await res.json();
              alert('Error: ' + data.message);
            }
          } catch (err) {
            alert('Error requesting verification.');
          }
        }}
      >
        Request Code
      </Button>
    </div>
    {showCodeInput && (
      <div className="flex gap-2 items-center">
        <input
          type="text"
          placeholder="Enter code"
          value={verificationCode}
          onChange={(e) => setVerificationCode(e.target.value)}
          className="border px-2 py-1 rounded text-sm"
        />
        <Button
          size="xs"
          onClick={async () => {
            try {
              const res = await fetchWithAuth(`${API}/api/whatsapp/verify-code`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ code: verificationCode }),
              });
              if (res.ok) {
                alert('Number verified successfully.');
                setShowCodeInput(false);
              } else {
                const data = await res.json();
                alert('Error verifying code: ' + data.message);
              }
            } catch (err) {
              alert('Error verifying code.');
            }
          }}
        >
          Verify
        </Button>
      </div>
    )}
  </div>
)}

        {whatsappDetails.displayName && (
          <div><strong>Display Name:</strong> {whatsappDetails.displayName}</div>
        )}
        {whatsappDetails.verifiedName && (
          <div><strong>Verified Name:</strong> {whatsappDetails.verifiedName}</div>
        )}
      </div>
      <Button
        className="mt-3"
        variant="destructive"
        onClick={disconnectWhatsApp}
      >
        🔌 Disconnect WhatsApp
      </Button>
    </>
  ) : (
    <>
      {!wabaSaved && (
        <Button onClick={startWhatsAppSignup}>
          📞 Connect WhatsApp Account
        </Button>
      )}

      
    </>
  )}
  {(
        <>
          <Badge variant="outline">Account Connected</Badge>
          <Button className="mt-2" onClick={maybeFinalize}>
            ☑️ Connect Phone Number
          </Button>
        </>
      )}
</StepCard>


          <StepCard title="Set Your Reply Preferences">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Select label="Tone" value={tone} onValueChange={setTone}>
                <SelectItem value="friendly">Friendly</SelectItem>
                <SelectItem value="professional">Professional</SelectItem>
                <SelectItem value="fun">Fun</SelectItem>
              </Select>
              <Select label="Language" value={language} onValueChange={setLanguage}>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="ar">Arabic</SelectItem>
                <SelectItem value="hi">Hindi</SelectItem>
              </Select>
              <Select label="CTA Style" value={ctaStyle} onValueChange={setCtaStyle}>
                <SelectItem value="direct">Direct</SelectItem>
                <SelectItem value="soft">Soft</SelectItem>
                <SelectItem value="promo">Promotional</SelectItem>
              </Select>
            </div>
          </StepCard>

          <StepCard title="Enable Auto-Reply">
            <div className="space-y-2">
              <ToggleSwitch
                label="Enable AI Auto-Reply for Instagram DMs"
                checked={autoReplyInstagram}
                onCheckedChange={setAutoReplyInstagram}
              />
              <ToggleSwitch
                label="Enable AI Auto-Reply for WhatsApp"
                checked={autoReplyWhatsApp}
                onCheckedChange={setAutoReplyWhatsApp}
              />
            </div>
          </StepCard>

          <Button className="w-full mt-6" onClick={handleSaveConfig}>
            Save & Continue to Inbox
          </Button>
        </div>
      </div>
    </AppShell>
  );
}

// OAuth Connect for Instagram
const launchOAuthConnect = (type) => {
  const appId = process.env.REACT_APP_META_APP_ID;
  const redirectUri = `https://app.ennoverse.ai/apps/replybot/connect/callback`;
  let scope = '';

  if (type === 'instagram') {
    scope = 'instagram_basic,instagram_manage_messages,pages_show_list,pages_read_engagement';
  }

  const oauthUrl = `https://www.facebook.com/dialog/oauth?client_id=${appId}&redirect_uri=${encodeURIComponent(
    redirectUri
  )}&state=${type}&scope=${scope}`;
  window.open(oauthUrl, '_blank');
};
